import React from "react";
import { Section, ToolbarButton } from "./UI";
import { useAuth } from "../contexts";

export function Help({ setView }) {
  const { user } = useAuth();
  const role = user?.role || "manager";
  
  return (
    <Section title="📖 Подсказка" right={<ToolbarButton onClick={() => setView("home")}>Меню</ToolbarButton>}>
      <div className="space-y-6">
        {/* Основные функции */}
        <div>
          <h3 className="font-semibold text-base mb-3 text-gray-900 dark:text-gray-100">📝 Работа с лидами</h3>
          <ul className="list-disc pl-5 space-y-2 text-sm text-gray-700 dark:text-gray-300">
            <li><strong>Событие</strong> — выбери конференцию из списка или укажи своё название через "Other".</li>
            <li><strong>Контакт</strong> — телеграм, почта, телефон или сайт. По контакту проверяются дубликаты.</li>
            <li><strong>Тип лида</strong> — Affiliate, Media Buyer, MDB Team, Influencer, Agency, Network, Direct Source, Payment System, Service Provider, Software или Other.</li>
            <li><strong>Источник трафика</strong> — TG, YouTube, TikTok, Instagram, FB, VK, Twitch/Kick, Influence, Arbitrage или Other (можно выбрать несколько).</li>
            <li><strong>Работает с нами?</strong> — Да / Нет / Не уверен (обязательно).</li>
            <li><strong>Модель комиссии</strong> — RevShare, CPA, Budget или Other с кастомной моделью (обязательно).</li>
            <li><strong>Фото</strong> — до 3 фото (селфи с партнером, визитки).</li>
            <li><strong>Заметки</strong> — до 1000 символов для договоренностей, бюджетов, GEO, ставок.</li>
            <li><strong>🤖 AI-сканер</strong> — сканируй визитку, и поля заполнятся автоматически.</li>
          </ul>
        </div>

        {/* Работа с голосовыми заметками и AI */}
        <div>
          <h3 className="font-semibold text-base mb-3 text-blue-600 dark:text-blue-400">🎤 Голосовые заметки и AI обработка</h3>
          <ul className="list-disc pl-5 space-y-2 text-sm text-gray-700 dark:text-gray-300">
            <li><strong>🎙️ Запись аудио</strong> — нажми на иконку микрофона, чтобы начать запись (максимум 60 секунд). Таймер автоматически остановит запись по достижению лимита.</li>
            <li><strong>⬆️ Транскрибация</strong> — после записи нажми на стрелку вверх для автоматической транскрибации голоса в текст. Аудио распознается с помощью OpenAI и добавляется в поле заметок.</li>
            <li><strong>🤖 AI обработка текста</strong> — нажми кнопку "🤖 AI" чтобы улучшить структуру и форматирование заметок:
              <ul className="list-circle pl-5 mt-1 space-y-1">
                <li>Исправляет опечатки и ошибки распознавания</li>
                <li>Структурирует текст по разделам: Обсуждение, Договоренности, Следующие шаги</li>
                <li>Выделяет важные данные жирным: суммы, сроки, даты</li>
                <li>Сохраняет оригинальный язык и стиль менеджера</li>
                <li>Форматирует в красивый Markdown</li>
              </ul>
            </li>
            <li><strong>↩️ Отменить изменения</strong> — если AI обработка не понравилась, нажми "↩️ Отменить" чтобы вернуть оригинальный текст. Backup автоматически очищается при сохранении лида.</li>
            <li><strong>👁️ Просмотр / ✏️ Редактирование</strong> — переключайся между режимом просмотра (с форматированием Markdown) и режимом редактирования (обычный текст).</li>
            <li><strong>❌ Удалить аудио</strong> — можешь удалить записанное аудио до транскрибации, если хочешь перезаписать.</li>
          </ul>
        </div>

        {/* Мои лиды */}
        <div>
          <h3 className="font-semibold text-base mb-3 text-gray-900 dark:text-gray-100">📋 Мои лиды</h3>
          <ul className="list-disc pl-5 space-y-2 text-sm text-gray-700 dark:text-gray-300">
            <li><strong>Фильтры</strong> — по событию, типу лида, статусу работы, модели комиссии, источнику и поиску по контакту.</li>
            <li><strong>Редактирование</strong> — нажми на карандаш для изменения лида.</li>
            <li><strong>Удаление</strong> — нажми на корзину.</li>
          </ul>
        </div>

        {/* Функции для админов */}
        {(role === "admin" || role === "super_admin") && (
          <div>
            <h3 className="font-semibold text-base mb-3 text-yellow-600 dark:text-yellow-400">🔑 Функции администратора</h3>
            <ul className="list-disc pl-5 space-y-2 text-sm text-gray-700 dark:text-gray-300">
              <li><strong>📊 Статистика</strong> — общая аналитика по лидам, менеджерам и событиям.</li>
              <li><strong>📋 Все лиды</strong> — просмотр всех лидов системы с фильтрами по менеджерам и всем параметрам (только просмотр, без редактирования).</li>
              <li><strong>💾 Экспорт CSV</strong> — выгрузка всех лидов в CSV-файл.</li>
            </ul>
          </div>
        )}

        {/* Функции для супер-админа */}
        {role === "super_admin" && (
          <div>
            <h3 className="font-semibold text-base mb-3 text-red-600 dark:text-red-400">🔐 Функции супер-админа</h3>
            <ul className="list-disc pl-5 space-y-2 text-sm text-gray-700 dark:text-gray-300">
              <li><strong>👥 Пользователи</strong> — управление пользователями: добавление, повышение/понижение роли, удаление.</li>
              <li><strong>🎉 События</strong> — управление списком конференций/событий.</li>
              <li><strong>🤖 AI Промпты</strong> — настройка системных промптов для AI обработки:
                <ul className="list-circle pl-5 mt-1 space-y-1">
                  <li><strong>🎤 Аудио транскрибация</strong> — промпт для распознавания голоса (OpenAI)</li>
                  <li><strong>📝 AI обработка текста</strong> — промпт для улучшения структуры заметок</li>
                  <li><strong>📷 OCR фото</strong> — промпт для распознавания текста с визиток</li>
                  <li>Можно создавать кастомные промпты или использовать оригинальные</li>
                  <li>Изменения применяются сразу после сохранения</li>
                  <li>Оригинальные промпты всегда доступны для восстановления</li>
                </ul>
              </li>
              <li><strong>⚠️ Полный доступ</strong> — ко всем функциям системы.</li>
            </ul>
          </div>
        )}

        {/* Ограничения */}
        <div>
          <h3 className="font-semibold text-base mb-3 text-gray-900 dark:text-gray-100">⚠️ Важно знать</h3>
          <ul className="list-disc pl-5 space-y-2 text-sm text-gray-700 dark:text-gray-300">
            <li>Дубликаты проверяются по полю <strong>"Контакт"</strong> — при попытке сохранить лида с существующим контактом система покажет предупреждение с информацией о том, кто уже добавил этот контакт, но вы сможете сохранить лида если это необходимо.</li>
            <li><strong>Голосовые заметки</strong> — аудио не сохраняется в базе, оно используется только для транскрибации и сразу удаляется.</li>
            <li><strong>AI обработка</strong> — работает с любым текстом в заметках, не только с транскрибированным. Можешь написать вручную и обработать её.</li>
            <li><strong>Разрешения на микрофон</strong> — браузер запросит разрешение при первой записи. В Telegram WebView разрешения могут сбрасываться при каждой сессии.</li>
          </ul>
        </div>
      </div>
    </Section>
  );
}
